import { Trans } from "@lingui/react/macro"
import { Tabs } from "@mantine/core"
import { Link } from "@tanstack/react-router"
import type { IProps } from "./interfaces"

import classes from "./styles.module.css"

/**
 * Summary / Details / Transcript for a narrow meeting page. Details and
 * Transcript are real links so the transcript route can open either meeting
 * tab. Summary stays a button on this page. Dumb: props in, tab changes out.
 */
export function MeetingTabs({ meetingId, current, onChange }: IProps): React.JSX.Element {
  return (
    <Tabs className={classes.tabs} value={current} data-testid="meeting-tabs">
      <Tabs.List className={classes.list}>
        <Tabs.Tab value="summary" onClick={() => onChange("summary")}>
          <Trans>Summary</Trans>
        </Tabs.Tab>
        <Tabs.Tab
          value="details"
          renderRoot={(props) => (
            <Link {...props} to="/meetings/$id" params={{ id: meetingId }} search={{ tab: "details" }} />
          )}
        >
          <Trans>Details</Trans>
        </Tabs.Tab>
        <Tabs.Tab
          value="transcript"
          renderRoot={(props) => <Link {...props} to="/meetings/$id/transcript" params={{ id: meetingId }} />}
        >
          <Trans>Transcript</Trans>
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  )
}
